import React from 'react';
import classNames from 'classnames/bind';
import styles from './Tabs.module.scss';

const cx = classNames.bind(styles);

function Tabs(props) {
	const { children = null, defaultActive = '', onClick = () => console.warn('onClick is not defined.'), style = null, useCustom = false, tabClass = '' } = props;
	const data = (Array.isArray(children) ? children : [children]).filter((item) => typeof item === 'object');
	const col = `col${data.length}`;
	const tab = data.map((item, i) => {
		const key = `tab${i}`;
		return (
			<li
				key={key}
				className={cx('tab', col, { active: defaultActive === item.props.activeName })}
			>
				<button
					type="button"
					className={cx('item')}
					onClick={() => onClick(item.props.activeName)}
				>
					{item.props.tab}
				</button>
			</li>
		);
	});
	const content = data.map((item, i) => {
		const key = `content${i}`;
		return (
			<div
				key={key}
				aria-hidden={defaultActive !== item.props.activeName}
				className={cx('content', { active: defaultActive === item.props.activeName })}
			>
				{item.props.children}
			</div>
		);
	});
	return (
		<>
			<ul
				className={cx('tabs', { normal: !useCustom }, tabClass)}
				style={style}
			>
				{tab}
			</ul>
			{content}
		</>
	);
}

export default Tabs;
